import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {SideNavBarComponent} from "../../shared/side-nav-bar/side-nav-bar.component";


type OrderSide = 'Kauf' | 'Verkauf';
type OrderType = 'Limit' | 'Market';
type InstrumentType = 'Stück' | 'Nominal';
type OrderStatus = 'Übermittelt' | 'Abgeschlossen' | 'Fehlgeschlagen' | 'Storniert';

interface OrderBookRow {
  id: number;
  instrument: string;
  isin: string;
  wkn: string;
  side: OrderSide;
  type: OrderType;
  instrumentType: InstrumentType;
  custodian: string;
  portfolio: string;
  account: string;
  venue: string;
  broker: string;
  submittedDate: string;
  validUntil: string;
  amount: string;
  quantity: string;
  executionPrice?: string;
  plannedPrice?: string;
  limit?: string;
  status: OrderStatus;
  executionStatus?: string;
  externalId?: string;
  createdBy?: string;
  orderStatusRaw?: string;
}


@Component({
  selector: 'app-order-book',
  standalone: true,
  imports: [CommonModule, SideNavBarComponent],
  templateUrl: './order-book.component.html',
  styleUrl: './order-book.component.scss'
})

export class OrderBookComponent {

  readonly orders: OrderBookRow[] = [
    {
      id: 1,
      instrument: 'Apple Inc',
      isin: 'US0378331005',
      wkn: '865985',
      side: 'Verkauf',
      type: 'Limit',
      instrumentType: 'Stück',
      custodian: '1',
      portfolio: '',
      account: '1',
      venue: 'BEX',
      broker: 'Rebalancing Sim...',
      submittedDate: '4/11/25',
      validUntil: '4/30/25',
      amount: '-20,140.00 USD',
      quantity: '-100 Stücke',
      executionPrice: '-',
      plannedPrice: '194.27 USD',
      limit: '201.4 USD',
      status: 'Übermittelt'
    },
    {
      id: 2,
      instrument: 'Demo | Deutsche Bank ...',
      isin: 'DE000PP9KM32',
      wkn: 'PP90M3',
      side: 'Kauf',
      type: 'Market',
      instrumentType: 'Stück',
      custodian: '1',
      portfolio: '',
      account: '1',
      venue: 'BEX',
      broker: 'Rebalancing Sim...',
      submittedDate: '4/11/25',
      validUntil: '4/2/25',
      amount: '0.21 EUR',
      quantity: '21 Verträge',
      plannedPrice: '0.001 EUR',
      status: 'Übermittelt'
    },
    {
      id: 3,
      instrument: 'United States Treasury ...',
      isin: 'US912810SE91',
      wkn: 'A2RT58',
      side: 'Kauf',
      type: 'Market',
      instrumentType: 'Nominal',
      custodian: 'John Doe',
      portfolio: '123.567.909_UBS',
      account: '123.567.909_U...',
      venue: 'BEX',
      broker: 'Rebalancing Sim...',
      submittedDate: '4/11/25',
      validUntil: '4/17/25',
      amount: '2,410.80 USD',
      quantity: '3,000 USD',
      plannedPrice: '80.36%',
      status: 'Übermittelt'
    },
    {
      id: 4,
      instrument: 'Allianz SE',
      isin: 'DE0008404005',
      wkn: '840400',
      side: 'Kauf',
      type: 'Market',
      instrumentType: 'Stück',
      custodian: '1',
      portfolio: '',
      account: '1',
      venue: 'BEX',
      broker: 'JP Morgan',
      submittedDate: '3/28/25',
      validUntil: '3/28/25',
      amount: '35,770.00 EUR',
      quantity: '100 Stücke',
      plannedPrice: '357.70 EUR',
      status: 'Übermittelt'
    },
    {
      id: 5,
      instrument: 'Apple Inc',
      isin: 'US0378331005',
      wkn: '865985',
      side: 'Kauf',
      type: 'Market',
      instrumentType: 'Stück',
      custodian: 'Jane Doe',
      portfolio: '190220.01',
      account: '19022001-KK-U...',
      venue: 'BEX',
      broker: 'Julius Bär',
      submittedDate: '3/4/25',
      validUntil: '3/4/25',
      amount: '134,486.95 USD',
      quantity: '565 Stücke',
      plannedPrice: '238.03 USD',
      status: 'Übermittelt'
    },
    {
      id: 6,
      instrument: 'Apple Inc',
      isin: 'US0378331005',
      wkn: '865985',
      side: 'Kauf',
      type: 'Market',
      instrumentType: 'Stück',
      custodian: 'Jane Doe',
      portfolio: '322.567.900_JB',
      account: 'Julius Bär - GBP ...',
      venue: 'BEX',
      broker: 'Julius Bär',
      submittedDate: '11/18/24',
      validUntil: '11/18/24',
      amount: '2,021,175.00 USD',
      quantity: '8,983 Stücke',
      plannedPrice: '225.00 USD',
      status: 'Übermittelt'
    },
    {
      id: 7,
      instrument: 'Novartis AG',
      isin: 'CH0012005267',
      wkn: '904278',
      side: 'Kauf',
      type: 'Limit',
      instrumentType: 'Stück',
      custodian: 'Jane Doe',
      portfolio: '345.567.900_JB',
      account: 'Julius Bär - USD ...',
      venue: 'BEX',
      broker: 'Julius Bär',
      submittedDate: '11/18/24',
      validUntil: '11/29/24',
      amount: '9,200.00 CHF',
      quantity: '100 Stücke',
      plannedPrice: '91.71 CHF',
      limit: '92 CHF',
      status: 'Übermittelt',
      externalId: 'Extern ID',
      createdBy: 'Marco Rinne'
    },
    {
      id: 8,
      instrument: 'Quantex Fds-Quan.Glo...',
      isin: 'LI0399611693',
      wkn: 'A2JEW4',
      side: 'Kauf',
      type: 'Market',
      instrumentType: 'Stück',
      custodian: 'John Doe',
      portfolio: '123.567.900_UBS',
      account: '123.567.900_U...',
      venue: 'BEX',
      broker: 'UBS',
      submittedDate: '10/22/24',
      validUntil: '10/22/24',
      amount: '19,590.76 USD',
      quantity: '62 Stücke',
      plannedPrice: '315.98 USD',
      status: 'Übermittelt'
    },
    {
      id: 9,
      instrument: 'GQG GLUCITS-GQG P.E...',
      isin: 'IE00BDGVJ060',
      wkn: 'A2DLAP',
      side: 'Kauf',
      type: 'Market',
      instrumentType: 'Stück',
      custodian: 'John Doe',
      portfolio: '123.567.900_UBS',
      account: '123.567.900_U...',
      venue: 'BEX',
      broker: 'UBS',
      submittedDate: '10/22/24',
      validUntil: '10/22/24',
      amount: '24,239.82 USD',
      quantity: '1,254 Stücke',
      plannedPrice: '19.33 USD',
      status: 'Übermittelt'
    },
    {
      id: 10,
      instrument: 'Comgest Growth PLC-E...',
      isin: 'IE00BYLVP044',
      wkn: 'A2AQA2',
      side: 'Kauf',
      type: 'Market',
      instrumentType: 'Stück',
      custodian: 'John Doe',
      portfolio: '123.567.900_UBS',
      account: '123.567.900_U...',
      venue: 'BEX',
      broker: 'UBS',
      submittedDate: '10/22/24',
      validUntil: '10/22/24',
      amount: '31,239.00 USD',
      quantity: '468 Stücke',
      plannedPrice: '66.75 USD',
      status: 'Übermittelt'
    },
    {
      id: 11,
      instrument: 'Well.Man.F.(L)-W.GL.Qu...',
      isin: 'LU0629158030',
      wkn: 'A1JGYJ',
      side: 'Kauf',
      type: 'Market',
      instrumentType: 'Stück',
      custodian: 'John Doe',
      portfolio: '123.567.900_UBS',
      account: '123.567.900_U...',
      venue: 'BEX',
      broker: 'UBS',
      submittedDate: '10/22/24',
      validUntil: '10/22/24',
      amount: '67,962.53 USD',
      quantity: '1,329 Stücke',
      plannedPrice: '51.1381 USD',
      status: 'Übermittelt'
    },
    {
      id: 12,
      instrument: 'Alpinum Credit Fund A...',
      isin: 'LU1082383057',
      wkn: '-',
      side: 'Kauf',
      type: 'Market',
      instrumentType: 'Stück',
      custodian: 'John Doe',
      portfolio: '123.567.900_UBS',
      account: '123.567.900_U...',
      venue: 'BEX',
      broker: 'UBS',
      submittedDate: '10/22/24',
      validUntil: '10/22/24',
      amount: '74,805.42 USD',
      quantity: '473 Stücke',
      plannedPrice: '158.151 USD',
      status: 'Übermittelt'
    }
  ];

  selected: OrderBookRow = this.orders[6];

  selectOrder(order: OrderBookRow): void {
    this.selected = order;
  }
}
